import client from "@/api/client"
import { PreviewEntityType } from "@/api/sdk"
import { DetailLayout } from "@/components/Layouts"
import { Metadata } from "@/components/Metadata"
import { clientUrl } from "@/constants"
import { capitalize } from "@/utils"
import useCustomRouter from "@/hooks/useCustomRouter"
import RecipeDetail from "@/components/Workspace/Recipes/RecipeDetail"

type RecipeDetailProps = {
  title: string
  description: string
  previewImage?: string
}

const RecipeDetailPage = ({ data }: { data: RecipeDetailProps }) => {
  const router = useCustomRouter()
  const { recipeId } = router.query

  return (
    <>
      <Metadata
        title={data.title}
        description={data.description}
        key={(recipeId as string) || data?.title}
        url={`${clientUrl}/workspace/tools/recipes/${recipeId}?t=${new Date().getTime()}`}
        previewImage={data.previewImage}
        type="website"
      />
      <RecipeDetail recipeId={recipeId as string} />
    </>
  )
}

RecipeDetailPage.getLayout = page => <DetailLayout>{page}</DetailLayout>

export default RecipeDetailPage

//server side rendering
export const getServerSideProps = async context => {
  const { recipeId } = context.params

  const name = capitalize((recipeId as string)?.replaceAll("-", " ") ?? "").replace("Ai", "AI")

  let data: RecipeDetailProps = {
    title: `GAIA | ${name} Recipe`,
    description: "Where Creativity In Production Meets Collaboration",
    previewImage: "",
  }

  try {
    const previewInfo = await client.api
      .previewControllerGetPreviewInfo({
        id: recipeId,
        type: PreviewEntityType.RECIPE,
      })
      .then(res => res.data)

    if (previewInfo) {
      data.title = `GAIA | ${previewInfo.name ?? name} Recipe`
      data.description = previewInfo.description ?? "Where Creativity In Production Meets Collaboration"
      data.previewImage = previewInfo.imageUrl
    }

    return {
      props: {
        data,
      },
    }
  } catch (error) {
    return {
      props: { data },
    }
  }
}
